import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import api from "../../Environment";
import ToastDemo from "./toaster";
import configuration from "react-global-configuration";
import {
  resolvePlaybackEngine,
  PlaybackEngineId,
} from "../../video-player/production/resolvePlaybackEngine";
import { clearStudioCapabilitiesCache } from "./studioCapabilities";

class Helper extends Component {
  state = {
    categories: {
      data: [],
    },
    recentUpload: [
      {
        data: [],
      },
      {
        data: [],
      },
    ],
    userDetails: {},
    data: {},
    errors: {},
    activeProfile: null,
    loading: true,
    videoDetailsFirst: null,
    loadingFirst: true,
    videoDetailsSecond: null,
    suggestion: null,
    loadingSuggestion: true,
    maindata: null,
    banner: null,
    wishlistApiCall: false,
    wishlistResponse: null,
    redirect: false,
    redirectPPV: false,
    redirectPaymentOption: false,
    redirectSubscription: false,
    loadingHomeSecondSection: false,
    homeSecondData: null,
    addNewProfileOption: null,
    onPlayStarted: false,
  };

  handleChange = ({ currentTarget: input }) => {
    const data = { ...this.state.data };
    data[input.name] = input.value;
    this.setState({ data });
  };

  getUserDetails() {
    api.postMethod("profile").then((response) => {
      if (response.data.success === true) {
        let data = response.data.data;
        this.setState({ loading: false, data: data });
      }
    });
  }

  viewProfiles() {
    api.postMethod("sub_profiles").then((response) => {
      if (response.data.success === true) {
        let activeProfile = response.data.data.sub_profiles;
        this.setState({
          loading: false,
          activeProfile: activeProfile,
          addNewProfileOption: response.data.data.is_new_sub_profile_allowed,
        });
      } else {
        this.errorCodeChecker(response.data.error_code);
      }
    });
  }

  singleVideoFirst(inputData) {
    api
      .postMethod("videos/view", inputData)
      .then((response) => {
        if (response.data.success === true) {
          let videoDetailsFirst = response.data.data;

          this.setState({
            loadingFirst: false,
            videoDetailsFirst: videoDetailsFirst,
          });
          this.singleVideoSecond(inputData);
        } else {
        }
      })
      .catch(function(error) {});
  }
  async onlySingleVideoFirst(inputData) {
    var self = this;
    try {
      var response = await api.postMethod("videos/view", inputData);
      if (response.data && response.data.success === true) {
        var videoDetailsFirst = response.data.data;
        this.setState({
          loadingFirst: false,
          videoDetailsFirst: videoDetailsFirst,
          videoDetailsError: null,
        });
        return videoDetailsFirst;
      }
      if (response.data && response.data.error_code) {
        this.errorCodeChecker(response.data.error_code);
      }
      this.setState({
        loadingFirst: false,
        videoDetailsError: response.data || { success: false },
      });
      return null;
    } catch (error) {
      var data =
        error && error.response && error.response.data
          ? error.response.data
          : null;
      if (data && data.error_code) {
        self.errorCodeChecker(data.error_code);
      }
      self.setState({
        loadingFirst: false,
        videoDetailsError: data || { success: false },
      });
      return null;
    }
  }
  singleVideoSecond(inputData) {
    api
      .postMethod("videos/view/second", inputData)
      .then((response) => {
        if (response.data.success === true) {
          let videoDetailsSecond = response.data.data;

          this.setState({
            loadingSecond: false,
            videoDetailsSecond: videoDetailsSecond,
          });
        } else {
        }
      })
      .catch(function(error) {});
  }
  suggestion(inputData) {
    api
      .postMethod("suggestions", inputData)
      .then((response) => {
        if (response.data.success === true) {
          let suggestion = response.data.data;

          this.setState({
            loadingSuggestion: false,
            suggestion: suggestion,
          });
        } else {
        }
      })
      .catch(function(error) {});
  }
  homeFirstSection(inputData) {
    // Ignore stale responses when Series/Movies/Category navigations overlap.
    this._homeSectionRequestId = (this._homeSectionRequestId || 0) + 1;
    const requestId = this._homeSectionRequestId;
    api
      .postMethod("home_first_section", inputData)
      .then((response) => {
        if (requestId !== this._homeSectionRequestId) {
          return;
        }
        if (response.data.success === true) {
          let maindata = response.data.data;
          let banner = response.data.banner;

          this.setState({
            loading: false,
            maindata: maindata,
            banner: banner,
            experience: response.data.experience || null,
          });
        } else {
          let errorHandle = 1;
          this.setState({ errorHandle });
          this.errorCodeChecker(response.data.error_code);
        }
        this.homeSecondSection(inputData, requestId);
      })
      .catch(function(error) {});
  }

  homeSecondSection(inputData, requestId) {
    const expectedId =
      requestId != null ? requestId : this._homeSectionRequestId;
    api
      .postMethod("home_second_section", inputData)
      .then((response) => {
        if (expectedId != null && expectedId !== this._homeSectionRequestId) {
          return;
        }
        if (response.data.success === true) {
          this.setState({
            loadingHomeSecondSection: false,
            homeSecondData: response.data.data,
          });
        } else {
          let errorHandle = 1;
          this.setState({ errorHandle });
        }
      })
      .catch(function(error) {});
  }

  wishlistUpdate(inputData) {
    api.postMethod("wishlists/operations", inputData).then((response) => {
      if (response.data.success === true) {
        ToastDemo(this.props.toastManager, response.data.message, "success");
        this.setState({
          wishlistResponse: response.data,
          wishlistApiCall: true,
        });
      } else {
        ToastDemo(
          this.props.toastManager,
          response.data.error_messages,
          "error"
        );
      }
    });
  }

  /**
   * Gate catalog → player redirects from a successful videos/view payload.
   * Missing flags must NOT be treated as PPV (undefined != 0 is true in JS).
   * @returns {"ppv"|"payment"|"subscription"|"play"|false}
   */
  redirectStatus(StatusData) {
    if (!StatusData || typeof StatusData !== "object") {
      return false;
    }
    // Error / incomplete payloads lack admin_video_id and gate flags.
    if (
      StatusData.success === false ||
      StatusData.admin_video_id == null ||
      StatusData.admin_video_id === ""
    ) {
      return false;
    }
    if (
      StatusData.should_display_ppv == null ||
      StatusData.is_user_need_subscription == null
    ) {
      return false;
    }

    var needsPpv =
      StatusData.should_display_ppv === 1 ||
      StatusData.should_display_ppv === "1" ||
      StatusData.should_display_ppv === true;
    var needsSub =
      StatusData.is_user_need_subscription === 1 ||
      StatusData.is_user_need_subscription === "1" ||
      StatusData.is_user_need_subscription === true;

    if (needsPpv) {
      if (StatusData.ppv_page_type == 2) {
        this.setState({ redirectPaymentOption: true });
        return "payment";
      }
      this.setState({ redirectPPV: true });
      return "ppv";
    }
    if (!needsSub) {
      this.setState({ redirect: true });
      return "play";
    }
    this.setState({ redirectSubscription: true });
    return "subscription";
  }

  renderRedirectPage(videoDetailsFirst, pageType) {
    if (this.state.redirect) {
      this.setState({ redirect: false });
      if (pageType == "videoPage") {
        // Don't do anything.
      } else {
        var engine = resolvePlaybackEngine({ configuration: configuration });
        // Default (nextgen / UMXP) and react-player rollback → unified /video/:id.
        // Explicit JW engine → historical /v/:id (except types that always used freeplayer).
        var forceFreeplayerTypes =
          videoDetailsFirst.video_type == 4 ||
          videoDetailsFirst.video_type == 2;
        var useJwRoute =
          engine === PlaybackEngineId.JW && !forceFreeplayerTypes;

        if (useJwRoute) {
          return (
            <Redirect
              to={{
                pathname: `/v/${videoDetailsFirst.admin_video_id}`,
                state: { videoDetailsFirst: videoDetailsFirst },
              }}
            />
          );
        }

        return (
          <Redirect
            to={{
              pathname: `/video/${videoDetailsFirst.admin_video_id}`,
              state: { videoDetailsFirst: videoDetailsFirst },
            }}
          />
        );
      }
    } else if (this.state.redirectPPV) {
      this.setState({ redirectPPV: false });

      return (
        <Redirect
          to={{
            pathname: "/pay-per-view",
            state: {
              videoDetailsFirst: videoDetailsFirst,
            },
          }}
        />
      );
    } else if (this.state.redirectPaymentOption) {
      this.setState({ redirectPaymentOption: false });

      return (
        <Redirect
          to={{
            pathname: "/payment-options",
            state: {
              videoDetailsFirst: videoDetailsFirst,
            },
          }}
        />
      );
    } else if (this.state.redirectSubscription) {
      this.setState({ redirectSubscription: false });
      return (
        <Redirect
          to={{
            pathname: "/subscription",
            state: {
              videoDetailsFirst: videoDetailsFirst,
            },
          }}
        />
      );
    } else {
      return null;
    }
  }
  errorCodeChecker(errorCode) {
    if (
      errorCode == 3000 ||
      errorCode == 3002 ||
      errorCode == 905 ||
      errorCode == 133 ||
      errorCode == 103 ||
      errorCode == 104
    ) {
      const hadSession =
        !!(localStorage.getItem("userId") && localStorage.getItem("accessToken"));

      localStorage.removeItem("accessToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("userLoginStatus");
      localStorage.removeItem("push_status");
      localStorage.removeItem("active_profile_id");
      localStorage.removeItem("userType");
      clearStudioCapabilitiesCache();

      // Public brand landings (/organization|/creator|/project) must stay
      // readable anonymously. Only bounce expired sessions to /login.
      const path =
        typeof window !== "undefined" && window.location
          ? String(window.location.pathname || "")
          : "";
      const isPublicEntityPath =
        /^\/(organization|creator|project)(\/|$)/i.test(path) ||
        /^\/org(\/|$)/i.test(path) ||
        /^\/organizations\/[^/]+/i.test(path) ||
        /^\/creators\/[^/]+/i.test(path) ||
        /^\/projects\/[^/]+/i.test(path);

      if (!hadSession || isPublicEntityPath) {
        return;
      }

      setTimeout(function() {
        window.location = "/login";
      }, 1000);
    }
  }
}

export default Helper;
